import { ReactNode, useCallback, useMemo } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { AdminContext, AdminUser } from './admin-context';

interface Props {
  children: ReactNode;
}

export const AdminProvider = ({ children }: Props) => {
  const adminUser = useMemo<AdminUser | null>(() => {
    const token = Cookies.get('admin_access_token');
    if (!token) return null;
    try {
      return jwtDecode<AdminUser>(token);
    } catch {
      return null;
    }
  }, []);

  const logout = useCallback(() => {
    Cookies.remove('admin_access_token');
    window.location.href = '/admin/login';
  }, []);

  return (
    <AdminContext.Provider value={{ adminUser, logout }}>
      {children}
    </AdminContext.Provider>
  );
};
